import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { CustomFieldsList } from '@config/components';

export const CustomFieldsPage = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t('config.sections.customFields')}</Page.Title>
      <Page.Content fill>
        <CustomFieldsList />
      </Page.Content>
    </Page>
  );
};
